import setting from './setting.js'
import http from "./http"
import ls from "./ls"
import mixpanel from "mixpanel-browser"

export default {
    // Ajax、MQTT通信通信のjson.statusに応じてメッセージを返す
    getErrorMessage (errorStatus, loginFlag = false) {
        let errorStr = ''
        switch (errorStatus) {
        // Ajax
        case 0:
            errorStr = setting.errorMessage.API.E90000
            break
        case 400:
            errorStr = setting.errorMessage.API.E90400
            break
        case 401:
            if (loginFlag) {
                errorStr = setting.errorMessage.API.E90401b
            } else {
                errorStr = setting.errorMessage.API.E90401
            }
            break
        case 404:
            if (loginFlag) {
                errorStr = setting.errorMessage.API.E90401b
            } else {
                errorStr = setting.errorMessage.API.E90404
            }
            break
            // MQTTエラー
        case 'EMQ000':
            errorStr = setting.errorMessage.MQTT.EMQ000
            break
        case 'EMQ001':
            errorStr = setting.errorMessage.MQTT.EMQ001
            break
        default:
            errorStr = setting.errorMessage.API.E90499
            break
        }
        return errorStr
    },
    // オブジェクトの配列の特定のキーを基準に並び替える
    ObjArraySort(ary, order, key, keyParent = null, type = 'String') {
        const reverse = order && order.toLowerCase() === 'desc' ? -1 : 1
        const getValue = (obj) => {
            const value = keyParent ? obj[keyParent][key] : obj[key]
            if (key === 'date') return new Date(value).getTime()
            return type === 'Number' ? Number(value) : value
        }

        return ary.sort((a, b) => {
            const dateA = getValue(a)
            const dateB = getValue(b)
            return (dateA < dateB ? -1 : dateA > dateB ? 1 : 0) * reverse
        })
    },
    // ユニフォーム番号を桁ごとに昇順に並び替える
    UniformNumSort(ary, order, keyParent = null) {
        const key = keyParent ? keyParent + '.uniform_number' : 'uniform_number'
        return ary.sortBy(r => (Object.get(r, key) | 0) , order && order.toLowerCase() === 'desc')
        // const reverse = order && order.toLowerCase() === 'desc' ? -1 : 1
        // const arrays = [[], [], [], [], []]
        //
        // ary.forEach(list => {
        //     const uniformNumber = list[keyParent]['uniform_number']
        //     const length = uniformNumber?.length
        //     const index = length > 0 && length <= 4 && uniformNumber !== '-' ? length - 1 : 4
        //     arrays[index].push(list)
        // })
        // const sort = (a, b) => {
        //     const numA = Number(a[keyParent]['uniform_number'])
        //     const numB = Number(b[keyParent]['uniform_number'])
        //     return (numA - numB) * reverse
        // }
        //
        // return arrays.flatMap(array => array.sort(sort))
    },
    getLevelStr (level) {
        if (level === 'NPB') {
            return '1軍'
        } else if (level === 'NPB Minors') {
            return '2軍'
        } else if (level === 'NPB Minors2') {
            return '3軍'
        } else {
            return '軍設定なし'
        }
    },
    // 投手と対戦でリアルタイムデータを取得した後のフィルタリングと値の置き換え（リアルタイムでないフォーマットに揃える）
    replaceRealtimeDataFormat (array, pitcherID) {
        let tmpData = []
        let count = 1
        array.forEach(function (d) {
            if (d.additional.pitcherId === pitcherID) {
                // Measurement XMLで上書きされているか（PitchSegmentがなければ上書き前）
                let pitchingDataPath = ''
                if (!('PitchSegment' in d.pitchingdata)) {
                    pitchingDataPath = d.pitchingdata
                } else {
                    pitchingDataPath = d.pitchingdata.PitchSegment
                }
                let obj = {}
                obj.pitchno = count
                obj.pitchingdata = {
                    'TaggedPitchType': d.additional.taggedPitchType,
                    'PitcherSet': d.additional.pitcherSet,
                    'Inning': d.additional.inning,
                    'RelSpeed': pitchingDataPath.ReleaseData.ReleaseSpeed * 3600,
                    'Extension': pitchingDataPath.ReleaseData.Extension,
                    'RelHeight': pitchingDataPath.ReleaseData.ReleaseHeight,
                    'RelSide': pitchingDataPath.ReleaseData.ReleaseSide,
                    'PlateLocSide': pitchingDataPath.TrajectoryData.LocationSide,
                    'PlateLocHeight': pitchingDataPath.TrajectoryData.LocationHeight,
                    'HorzBreak': pitchingDataPath.TrajectoryData.HorizontalBreak,
                    'InducedVertBreak': pitchingDataPath.TrajectoryData.VerticalBreakInduced,
                    'Rifle': 0,
                    'w_sin_a': 0,
                    'DeflectionAngle': 0,
                    'SpinRate': 0,
                    'Depth': 0,
                    'KorBB': d.additional.KorBB,
                    'HitType': d.additional.hitType,
                    'PitchCall': d.additional.pitchCall,
                    'PlayResult': d.additional.playResult,
                    'BatterAtBat': d.additional.batterAtBat,
                    'batterTeam': d.additional.batterTeam,
                    'pitcherId': d.additional.pitcherId,
                    'pitcherTeam': d.additional.pitcherTeam,
                    'topBottom': d.additional.topBottom
                }
                obj.Batter = {
                    'identifier': d.additional.batterId,
                    'name': d.additional.batterName,
                    'additional': {
                        'uniform_number': d.additional.batterUniformNumber
                    }
                }
                obj.batterside = d.additional.batterSide
                count++
                tmpData.push(obj)
            }
        })
        tmpData.reverse()
        return tmpData
    },
    filterGameDetail(filteredPitches, cond) {
        const filters = [
            { key: 'formTypeStr', field: 'BatterSide' },
            { key: 'formBatterStr', field: 'BatterId' },
            { key: 'formCountStrikes', field: 'Strikes' },
            { key: 'formCountBalls', field: 'Balls' },
            { key: 'formCountOuts', field: 'Outs' },
            { key: 'formInning', field: 'Inning' },
            { key: 'formReleasePosition', field: 'PitcherSet' },
            { key: 'formHitType', field: 'HitType' },
            { key: 'formPlayResult', field: 'PlayResult' },
        ]

        filters.forEach(({ key, field }) => {
            if (cond[key] !== '') {
                filteredPitches = filteredPitches.filter(d => d.pitchingdata[field] === cond[key])
            }
        })

        if (cond.formScore !== '') {
            filteredPitches = filteredPitches.filter(d => {
                const spread = d.pitchingdata.Point.Spread
                return cond.formScore === '-5' ? spread <= -5 :
                    cond.formScore === '5' ? spread >= 5 :
                        spread === Number(cond.formScore)
            })
        }

        if (cond.formPitchCall !== '') {
            filteredPitches = filteredPitches.filter(d => {
                const { PitchCall, Zone } = d.pitchingdata
                return cond.formPitchCall === 'StrikeSwingingZone' ? (PitchCall === 'StrikeSwinging' && Zone === 'Zone') :
                    cond.formPitchCall === 'StrikeSwingingO-Zone' ? (PitchCall === 'StrikeSwinging' && Zone === 'O-Zone') :
                        PitchCall === cond.formPitchCall
            })
        }

        if (cond.formKorBB !== '') {
            filteredPitches = filteredPitches.filter(d => d.pitchingdata.KorBB === cond.formKorBB)
        }

        return filteredPitches
    },
    isPlatform () {
        if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
            return 'iPad'
        } else {
            return 'PC'
        }
    },
    setUniNumSpace (uniformNumber) {
        if (this.isPlatform() === 'PC') {
            if (uniformNumber.length === 1) {
                if (uniformNumber !== '-') {
                    return '&ensp;&ensp;&ensp;'
                } else {
                    return '&ensp;&ensp;&ensp;&ensp;'
                }
            } else if (uniformNumber.length === 2) {
                return '&ensp;&ensp;'
            } else if (uniformNumber.length === 3) {
                return '&ensp;'
            } else {
                return ''
            }
        } else {
            if (uniformNumber.length === 1) {
                if (uniformNumber !== '-') {
                    return '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&thinsp;&thinsp;'
                } else {
                    return '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&thinsp;&thinsp;&thinsp;'
                }
            } else if (uniformNumber.length === 2) {
                return '&nbsp;&nbsp;&nbsp;&thinsp;'
            } else if (uniformNumber.length === 3) {
                return '&nbsp;&nbsp;'
            } else {
                return ''
            }
        }
    },
    /*
     * チェック機能
     */
    // LSに指定したプレイヤー（レポートの場合は＋gameID）が含まれるか
    searchListOfChecked (targetList, playerID, gameID = null, termReportID = null) {
        let result = false
        let listOfCheckedArray = (ls.get(targetList))
        if (listOfCheckedArray === undefined || listOfCheckedArray === null) {
            return result
        }
        listOfCheckedArray.forEach((d, index) => {
            if (gameID === null) {
                if (d.pitcherID === playerID) {
                    // ピッチャーの場合
                    result = true
                } else if (d.identifier === playerID) {
                    // 打者の場合
                    result = true
                } else if (d.termReportID === termReportID) {
                    // 期間レポートの場合
                    result = true
                } else if (d.umpire_code === playerID) {
                    // 審判の場合
                    result = true
                }

            } else {
                // 試合レポートの場合
                if (d.pitcherID === playerID && d.gameID === gameID) {
                    result = true
                }
            }
        })
        return result
    },
    // チェックした投手・レポートリストをLSに追加、もしくは削除するための振り分け
    changeCheck (targetList, data, checkedFlag) {
        if (checkedFlag) {
            return this.addCheckList(targetList, data)
        } else {
            return this.deleteCheckList(targetList, data)
        }
    },
    // リストに重複がなければ追加
    addCheckList (targetList, data) {
        let listOfCheckedArray = (ls.get(targetList))
        if (listOfCheckedArray === null) {
            listOfCheckedArray = []
        }
        if (data.gameID === undefined) {
            if (data.termReportID !== undefined) {
                // 期間レポートの場合
                if (!this.searchListOfChecked(targetList, null, null, data.termReportID)) {
                    listOfCheckedArray.push(data)
                    ls.set(targetList, (listOfCheckedArray))
                }
            } else if (data.pitcherID !== undefined) {
                // ピッチャーの場合
                if (!this.searchListOfChecked(targetList, data.pitcherID)) {
                    listOfCheckedArray.push(data)
                    ls.set(targetList, (listOfCheckedArray))
                }
            } else if (data.umpire_code !== undefined) {
                // 審判の場合
                if (!this.searchListOfChecked(targetList, data.umpire_code)) {
                    listOfCheckedArray.push(data)
                    ls.set(targetList, (listOfCheckedArray))
                }
            } else {
                // 打者の場合
                if (!this.searchListOfChecked(targetList, data.identifier)) {
                    listOfCheckedArray.push(data)
                    ls.set(targetList, (listOfCheckedArray))
                }
            }
        } else {
            // 試合レポートの場合
            if (!this.searchListOfChecked(targetList, data.pitcherID, data.gameID)) {
                listOfCheckedArray.push(data)
                ls.set(targetList, (listOfCheckedArray))
            }
        }
    },
    // LSから指定されたピッチャーを削除
    deleteCheckList (targetList, data) {
        let listOfCheckedArray = (ls.get(targetList))
        let deleteIndex = -1
        listOfCheckedArray.forEach((d, index) => {
            if (data.gameID === undefined) {
                if (data.termReportID !== undefined) {
                    // 期間レポートの場合
                    if (d.termReportID === data.termReportID) {
                        deleteIndex = index
                    }
                } else if (data.pitcherID !== undefined) {
                    // ピッチャーの場合
                    if (d.pitcherID === data.pitcherID) {
                        deleteIndex = index
                    }
                } else if (data.umpire_code !== undefined) {
                    // 審判の場合
                    if (d.umpire_code === data.umpire_code) {
                        deleteIndex = index
                    }
                } else {
                    // 打者の場合
                    if (d.identifier === data.identifier) {
                        deleteIndex = index
                    }
                }
            } else {
                // 試合レポートの場合
                if (d.pitcherID === data.pitcherID && d.gameID === data.gameID) {
                    deleteIndex = index
                }
            }
        })
        listOfCheckedArray.splice(deleteIndex, 1)
        ls.set(targetList, (listOfCheckedArray))
    },

    /*
     * 3D軌跡
     */

    // ピッチトンネル最小包含円のxr、yr、rmin
    getMinimumCircleInfo (xx, yy, pos) {
        // console.log('getMinimumCircleInfo', ballArray, pos)

        //-------------------------------------
        // ConvexHull
        //-------------------------------------
        const NMAX = 500                // max.# of data
        let n = 0                     // # of data                         座標の数
        // let xx = new Array(NMAX);      // x                                 各X座標の配列
        // let yy = new Array(NMAX);      // y                                 各Y座標の配列
        const xc = 0, yc = 0            // added or deleted point
        let xpos = 0, ypos = 0        // cursor pos.                       タップした場所の座標
        let xpos1, ypos1              //   nearest poi.
        const strc = ""

        let na = 0                    // 凸包
        const xa = new Array(NMAX + 1)    // x                                  xxの配列の最後にxxの1番目を追加した配列
        const ya = new Array(NMAX + 1)    // y                                  yyの配列の最後にyyの1番目を追加した配列

        let rmin = 0                  // 最小包含円
        let xr, yr

        let g, w = 500, h = 500, maxS = 500
        let w1, h1, x0, y0, dx, dy

        n = xx.length
        // console.log(xx, yy)
        return calc1()

        //..........................
        function calc0() { // hull                 データの整形をしている
            //..........................
            if (n < 2) return

            let ymin = 9999
            let im = 0
            rmin = 0

            let i = 0
            for (i = 0; i < n; i++) {
                if (yy[i] < ymin) {
                    ymin = yy[i]
                    im = i
                }
            }
            na = 1
            xa[0] = xx[im]
            ya[0] = yy[im]

            let im0 = im
            let is = im
            let xs = xa[0], ys = ya[0]
            let v0 = [1., 0., 0.]
            let v1 = new Array(3)
            let v2 = new Array(3)

            for (let j = 0; j < n; j++) {
                let amin = 99999
                for (i = 0; i < n; i++) {
                    if (i === is) continue
                    v1[0] = xx[i] - xs
                    v1[1] = yy[i] - ys
                    v1[2] = 0
                    vnrm(v1) // <-
                    v2 = vepd(v0, v1)
                    let sina = v2[2]
                    let cosa = vipd(v0, v1)
                    let ang = Math.atan2(sina, cosa)
                    if (ang < 0) ang += 2 * Math.PI
                    if (ang < amin) {
                        amin = ang
                        im = i
                    }
                }
                xs = xa[na] = xx[im]
                ys = ya[na] = yy[im]
                is = im
                v0[0] = xs - xa[na - 1]
                v0[1] = ys - ya[na - 1]
                vnrm(v0)
                na++
                if (im === im0) break
            }

            // disp();
        }

        //..........................
        function calc1() { // cir.
            //..........................
            if (n < 2) return

            calc0()

            let m = na - 1
            let x1, y1, x2, y2, x3, y3, d = 0
            let eps = 1.0e-3

            if (m < 3) {
                rmin = Math.sqrt((xa[1] - xa[0]) * (xa[1] - xa[0]) + (ya[1] - ya[0]) * (ya[1] - ya[0])) / 2
                xr = (xa[0] + xa[1]) / 2
                yr = (ya[0] + ya[1]) / 2
                return disp()
            }

            for (let i1 = 0; i1 < m; i1++) {
                x1 = xa[i1]
                y1 = ya[i1]

                for (let i2 = i1 + 1; i2 < m; i2++) {
                    x2 = xa[i2]
                    y2 = ya[i2]

                    for (let i3 = i2 + 1; i3 < m; i3++) {
                        x3 = xa[i3]
                        y3 = ya[i3]
                        let c = calc1a(x1, y1, x2, y2, x3, y3)
                        let flag = 0

                        for (let j = 0; j < m; j++) {
                            d = Math.sqrt((xa[j] - c[0]) * (xa[j] - c[0]) + (ya[j] - c[1]) * (ya[j] - c[1]))
                            if (d > c[2] + eps) {
                                flag = j + 1
                                break
                            }
                        }

                        if (flag === 0) {
                            rmin = c[2]
                            xr = c[0]
                            yr = c[1]
                            return disp()
                        }
                    }
                }
            }
            return disp()
        }

        //..................................................................
        function calc1a(x1, y1, x2, y2, x3, y3) { // 3点の最小包含円
            //..................................................................
            let c = new Array(3) // center x,y & r
            let v123 = (x2 - x1) * (x3 - x2) + (y2 - y1) * (y3 - y2) // 12・23 内積
            let v231 = (x3 - x2) * (x1 - x3) + (y3 - y2) * (y1 - y3)
            let v312 = (x1 - x3) * (x2 - x1) + (y1 - y3) * (y2 - y1)

            if (v123 < 0 && v231 < 0 && v312 < 0) { // 鋭角3角形
                let x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2
                let v12 = [x2 - x1, y2 - y1, 0.]
                vnrm(v12)
                vrot90(v12)
                let x13 = (x1 + x3) / 2, y13 = (y1 + y3) / 2
                let v13 = [x3 - x1, y3 - y1, 0.]
                vnrm(v13)
                vrot90(v13)
                let d = -(v12[0] * v13[1] - v12[1] * v13[0])
                let ds = -(x13 - x12) * v13[1] + (y13 - y12) * v13[0]
                //    let dt = v12[0]*(y13-y12) - v12[1]*(x13-x12);
                let s = ds / d
                //    let t = dt/d;
                c[0] = x12 + s * v12[0]
                c[1] = y12 + s * v12[1]
                c[2] = Math.sqrt((x1 - c[0]) * (x1 - c[0]) + (y1 - c[1]) * (y1 - c[1]))
            } else {                                // 鈍角
                if (v123 >= 0) {
                    c[0] = (x1 + x3) / 2
                    c[1] = (y1 + y3) / 2
                    c[2] = Math.sqrt((x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3)) / 2
                } else if (v231 >= 0) {
                    c[0] = (x1 + x2) / 2
                    c[1] = (y1 + y2) / 2
                    c[2] = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2)) / 2
                } else {
                    c[0] = (x2 + x3) / 2
                    c[1] = (y2 + y3) / 2
                    c[2] = Math.sqrt((x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3)) / 2
                }
            }

            return c
        }

        //.........................
        function vepd(v1, v2) {
            //.........................
            let v = new Array(3)
            v[0] = v1[1] * v2[2] - v1[2] * v2[1]
            v[1] = v1[2] * v2[0] - v1[0] * v2[2]
            v[2] = v1[0] * v2[1] - v1[1] * v2[0]
            return v
        }

        //..........................
        function vipd(v1, v2) {
            //..........................
            return v1[0] * v2[0] + v1[1] * v2[1] + v1[2] * v2[2]
        }

        //..........................
        function vnrm(v) {
            //..........................
            let d = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2])
            for (let i = 0; i < 3; i++) v[i] /= d

            return d
        }

        //..........................
        function vrot90(v) {
            //..........................
            let v0 = v[0]
            v[0] = -v[1]
            v[1] = v0
        }


        function disp() {
            // console.log('rmin:', rmin, 'xr:', xr, 'yr:', yr)
            pos.x = xr * 100
            pos.y = yr * 100
            pos.r = rmin * 100
            return pos
        }
    },
    // ログ送信
    LOG (level, page, action = null, text1 = null, text2 = null) {
        let obj = {
            'level': level,
            'page': page,
            'UA': window.navigator.userAgent
        }
        if (action !== null) obj.action = action
        if (text1 !== null) obj.text1 = text1
        if (text2 !== null) obj.text2 = text2
        window.setTimeout(function () {
            http('logs', {}, 'POST', JSON.stringify(obj))
        }, 2000)
        if (page) {
            mixpanel.track(page, {
                action, text1, text2
            })
        }
    },
    /*
     * 管理画面用閾値計算
     */
    // 閾値から上回った、下回った、変わらずを判定
    judgeThreshold(baseDataObj, comparisonObj) {
        const result = {}
        const propatyArray = ['prev', 'aver', 'past', 'pMax', 'NPB']

        for (const state in comparisonObj) {
            for (const type in comparisonObj[state]) {
                for (const propaty in comparisonObj[state][type]) {
                    const baseValue = baseDataObj[state]?.[type]?.[propaty]
                    if (baseValue === undefined) continue

                    for (const d of propatyArray) {
                        const comparison = comparisonObj[state][type][propaty][d]
                        if (comparison === undefined) continue

                        result[state] = result[state] || {}
                        result[state][type] = result[state][type] || {}
                        result[state][type][propaty] = result[state][type][propaty] || {}

                        if (baseValue < comparison.min) {
                            result[state][type][propaty][d] = -1
                        } else if (baseValue > comparison.max) {
                            result[state][type][propaty][d] = 1
                        } else {
                            result[state][type][propaty][d] = 0
                        }

                        if (d === 'past') {
                            result[state][type][propaty].pastType = comparison.type
                        }
                    }
                }
            }
        }
        return result
    }
}
